import { CircularProgress, createStyles, makeStyles, Theme } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import classNames from 'classnames';
import React from 'react';

import { spacings } from '../../../theme';
import { ButtonColor } from '../../shared/primitives/PlexButton';
import { IconButtonSize, PlexIconButton } from '../../shared/primitives/PlexIconButton';
import { usePlexRoute } from './usePlexRoute';

export type DetailsProps = {
  loading?: boolean;
  children?: React.ReactNode;
};

type TopBarProps = {
  className?: string;
  loading?: boolean;
  children?: React.ReactNode;
  onClose: () => void;
};

export function TopBar({ className, loading, children, onClose }: TopBarProps): React.ReactElement {
  const classes = useStyles();
  return (
    <div className={classNames(classes.root, className)}>
      {loading && <CircularProgress />}
      {children}
      <div>
        <PlexIconButton
          className={classes.closeButton}
          onClick={onClose}
          MuiIcon={CloseIcon}
          color={ButtonColor.TransparentGray}
          tooltip={'Close'}
          size={IconButtonSize.Normal}
        />
      </div>
    </div>
  );
}

export function DetailsTopBar({ loading, children }: DetailsProps): React.ReactElement {
  const [, updatePlexRoute] = usePlexRoute();
  const handleCloseDetailedView = (): void => {
    updatePlexRoute({ selectedItem: undefined });
  };

  return <TopBar loading={loading} children={children} onClose={handleCloseDetailedView} />;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexDirection: 'row',
      paddingRight: spacings.normal,

      borderBottomWidth: 1,
      borderBottomColor: '#ECECF2',
      borderBottomStyle: 'solid',
    },
    closeButton: {
      marginLeft: 'auto',
    },
  })
);
